export default __webpack_public_path__ + "static/spiritual-india-places-6-255c8f46fd0fddf34fef7ebc6a07c77d.jpg";